export default __webpack_public_path__ + "static/media/mc_settings_button_invalid.eee7aec2.svg";